App.filter('statusLifeFilter', function () {
    return function (el) {
        el = el || '';

        var dictionary = [];
        
        dictionary['ALL'] = 'Wszyscy';
        dictionary['NEW'] = 'Nowi';
        dictionary['WITHDRAWAL'] = 'Wystąpienia';
        dictionary['CHANGES'] = 'Zmiany';

        if (el) {
        	if (dictionary[el]) {
        		return dictionary[el];
        	} else {
        		return el;
        	}
        }

        return el;
    };
})